import { indexOf } from 'ramda';
import { combineReducers } from 'redux';

import {
  LOAD_DOCUMENT_BY_ID_FAILURE,
  LOAD_DOCUMENT_BY_ID_REQUEST,
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_FAILURE,
  LOAD_DOCUMENT_BY_UID_REQUEST,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_DOCUMENTS_BY_IDS_FAILURE,
  LOAD_DOCUMENTS_BY_IDS_REQUEST,
  LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  LOAD_PAGINATED_QUERY_FAILURE,
  LOAD_PAGINATED_QUERY_REQUEST,
  LOAD_PAGINATED_QUERY_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_FAILURE,
  LOAD_SINGLE_TYPE_DOC_REQUEST,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
} from '../actions/prismic';

const getAllTypes = ([requestType, successType, failureType]: string[]): Record<
  string,
  string | string[]
> => ({
  REQUEST_TYPES: requestType,
  ENDING_TYPES: [successType, failureType],
});

const loader = ({
  types,
  mapActionToKey,
}: {
  types: string[];
  mapActionToKey?: (action: Record<string, any>) => string;
}): ((state: LoadersState, action: any) => LoadersState) => {
  const { REQUEST_TYPES } = getAllTypes(types);

  const updateKeyedLoader = (
    state: Record<string, boolean> = {},
    action: any
  ): Record<string, boolean> => {
    const key = mapActionToKey(action);

    return {
      ...state,
      [key]: action.type === REQUEST_TYPES,
    };
  };

  const updateLocalizedLoader = (
    state: LoadersState,
    action: any
  ): LoadersState => ({
    ...state,
    [action.lang]: updateKeyedLoader(state[action.lang], action),
  });

  return (state: LoadersState = {}, action: any): LoadersState => {
    if (indexOf(action.type, types) >= 0 && action.lang) {
      return updateLocalizedLoader(state, action);
    }

    return state;
  };
};

export default combineReducers({
  loadDocById: loader({
    types: [
      LOAD_DOCUMENT_BY_ID_REQUEST,
      LOAD_DOCUMENT_BY_ID_SUCCESS,
      LOAD_DOCUMENT_BY_ID_FAILURE,
    ],
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocByUid: loader({
    types: [
      LOAD_DOCUMENT_BY_UID_REQUEST,
      LOAD_DOCUMENT_BY_UID_SUCCESS,
      LOAD_DOCUMENT_BY_UID_FAILURE,
    ],
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocByIds: loader({
    types: [
      LOAD_DOCUMENTS_BY_IDS_REQUEST,
      LOAD_DOCUMENTS_BY_IDS_SUCCESS,
      LOAD_DOCUMENTS_BY_IDS_FAILURE,
    ],
    mapActionToKey: (action: any) => action.ids,
  }),
  loadDocByType: loader({
    types: [
      LOAD_SINGLE_TYPE_DOC_REQUEST,
      LOAD_SINGLE_TYPE_DOC_SUCCESS,
      LOAD_SINGLE_TYPE_DOC_FAILURE,
    ],
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocs: loader({
    types: [
      LOAD_PAGINATED_QUERY_REQUEST,
      LOAD_PAGINATED_QUERY_SUCCESS,
      LOAD_PAGINATED_QUERY_FAILURE,
    ],
    mapActionToKey: (action: any) => action.key,
  }),
});

export type Loader = Record<string, boolean>;
export type LoadersState = Record<string, Loader>;
